import { SearchResultsItem } from "../SearchContents/SearchContents";
import { ResultColumn } from "../SearchContents/SearchResults";
import {
    composeTableData,
    composeTableHeaders,
} from "../SearchResultsTable/composeTableData";
import { RowData } from "../SearchResultsTable/BodyRow";

export const composeCards = (
    columns: ResultColumn[],
    items: SearchResultsItem[]
): RowData[] => {
    const headers = composeTableHeaders(columns);
    return composeTableData(headers, items);
};
